// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__qW8EC","active":"Pagination_active__Evcgf"};